"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
exports.AUDIT_SERVICE = new core_1.InjectionToken("Provide your implementation of AuditServiceInterface");
//# sourceMappingURL=audit.service.interface.js.map